"use client";

import ProductCard from "@/components/product/ProductCard";
import SectionHeader from "@/components/motion/SectionHeader";
import type { FeaturedCollection as FeaturedCollectionData } from "@/lib/validations/cms";
import type { ProductCardProps } from "@/types/product";
import EditableText from "@/components/edit-mode/EditableText";

export default function FeaturedCollectionClient({
  data,
  featuredProducts,
}: {
  data: FeaturedCollectionData;
  featuredProducts: ProductCardProps[];
}) {
  const titleWords = data.title.split(" ");

  return (
    <section className="border-foreground bg-background border-b py-12 md:py-24">
      <div className="mx-auto max-w-[1920px] px-4 sm:px-6 lg:px-8">
        <SectionHeader
          title={
            <EditableText
              section="featuredCollection"
              field="title"
              value={data.title}
              as="span"
              className="inline"
            >
              <span>
                {titleWords[0]}
                <br />
                {titleWords.slice(1).join(" ") || titleWords[0]}
              </span>
            </EditableText>
          }
          subtitle={
            <EditableText section="featuredCollection" field="subtitle" value={data.subtitle} />
          }
          linkText={
            <EditableText section="featuredCollection" field="linkText" value={data.linkText} />
          }
          href="/products"
        />

        <div className="grid grid-cols-2 gap-x-4 gap-y-8 md:gap-x-6 md:gap-y-12 lg:grid-cols-4">
          {featuredProducts.map((product: ProductCardProps, index: number) => (
            <ProductCard
              key={product.id}
              name={product.name}
              price={product.price}
              images={product.images}
              id={product.id}
              sizes={product.sizes}
              stock={product.stock}
              is_preorder={product.is_preorder}
              low_stock_threshold={product.low_stock_threshold}
              index={index}
            />
          ))}
          {featuredProducts.length === 0 && (
            <p className="text-muted-foreground col-span-full py-12 text-center">
              <EditableText
                section="featuredCollection"
                field="emptyState"
                value={data.emptyState}
              />
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
